///<reference path="../short-cuts.interfaces.ts"/>

module Meevo.Components.ShortCuts {

    //#endregionImports

    export class ShortCutCombination implements IShortCutCombination {
        public readonly description: string;
        public readonly allowIn: CombinationAllowInTypes[];
        public mainKey: string;
        public secondaryKey: string;
        public readonly securityKey: string;

        get combination() {
            return [this.mainKey, this.secondaryKey, this.key]
                .filter(v => !!v)
                .join('+');
        }

        constructor(public key: string, private options: IShortCutCombinationOptions = <IShortCutCombinationOptions>{}) {
            _.extend(this, options);

            this.allowIn = this.allowIn || ['INPUT', 'SELECT', 'TEXTAREA'];
            this.securityKey = options.securityKey || null;
            this.update(this.key);
        }

        /**
         * Method parses the hotkey combination and apply data to the properties
         *
         * @example
         * shortKeyCombination.update('ctrl+alt+delete');
         * @example
         * shortKeyCombination.update('ctrl+t');
         * @example
         * shortKeyCombination.update('delete');
         *
         * @param combination
         */
        public update(combination: string): void {
            const letters: string[] = combination.split('+');

            switch (letters.length) {
                case (1):
                    this.key = letters[0];
                    break;
                case (2):
                    this.key = letters[1];
                    this.mainKey = letters[0];
                    break;
                case (3):
                    this.key = letters[2];
                    this.secondaryKey = letters[1];
                    this.mainKey = letters[0];
                    break;
            }
        }
    }
}